// @ts-nocheck
// datatable related plugins
import { yupResolver } from "@hookform/resolvers/yup";
import { ALL_BU, ALL_STORE } from "constants/DashboardContanst";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import {
  generateDateField,
  generateSelectField,
} from "helpers/form_helper_old";
import { checkIsHaveInvoicePos, convertDate } from "helpers/utils";
import { TypeHDList } from "pages/Error-invoice/utils";
import { getInvoiceStatus } from "pages/IssueInvoice/helper/functionHelper";
import { getTimeContent } from "pages/ReportZipFile/helper/functionHelper";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useToasts } from "react-toast-notifications";
import { Button, Card, CardBody, Col, Label, Progress, Row } from "reactstrap";
import {
  DOWNLOAD_REPORT_INVOICE_FAIL,
  DOWNLOAD_REPORT_INVOICE_SUCCESS,
} from "store/summary-invoice-data/actionTypes";
import {
  createReportInvoice,
  downloadReportInvoice,
  listKhddInvoiceToSummary,
  resetDownloadReportInvoice,
  resetGetReportInvoiceProgress,
} from "store/summary-invoice-data/actions";
import * as yup from "yup";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { TYPE_REPORT } from "./helper/functionHelper";

const CreateData = props => {
  const [optionYear, setOptionYear] = useState(null);
  const [nameFile, setNameFile] = useState(null);
  const dispatch = useDispatch();

  const issueInvoice = useSelector(state => state.issueInvoice);
  const { currentTime } = issueInvoice;

  const Dashboard = useSelector(state => state.Dashboard);
  const {
    buTenantHeader,
    listBuStore,
    buTenantHeaderInfo,
    finalBuInfo,
    buStoreHeader,
    tenantCodeHeader,
  } = Dashboard;

  useEffect(() => {
    if (buStoreHeader) {
      setValue("bu_code_filter", []);
    }
  }, [buStoreHeader]);

  const initOptionDateLocale = {
    altInput: true,
    altFormat: "d/m/Y",
    dateFormat: "d/m/Y",
    allowInput: true,
    locale: {
      ...Vietnamese,
      firstDayOfWeek: 1,
    },
  };

  const [optionDateLocale, setOptionDateLocale] = useState({
    ...initOptionDateLocale,
  });

  // store reducer
  const summaryInvoiceData = useSelector(state => state.summaryInvoiceData);
  const {
    listKHHD,
    reportInvoiceProgress,
    createReportInvoiceData,
    type,
    fileDownload,
    fileDownloadName,
  } = summaryInvoiceData;

  const history = useHistory();

  useEffect(() => {
    switch (type) {
      case DOWNLOAD_REPORT_INVOICE_SUCCESS: {
        if (fileDownload !== null) {
          const link = document.createElement("a");
          link.href = fileDownload;
          link.setAttribute("download", fileDownloadName);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetDownloadReportInvoice());
        break;
      }
      case DOWNLOAD_REPORT_INVOICE_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDownloadReportInvoice());
        break;
    }
  }, [type]);

  useEffect(() => {
    dispatch(listKhddInvoiceToSummary(getValues("khmshdon").value));
    return () => {
      dispatch(resetGetReportInvoiceProgress());
    };
  }, []);

  useEffect(() => {
    if (currentTime) {
      let currentYear = currentTime?.data?.year;
      const listYear = [];
      for (let i = 0; i < 3; i++) {
        listYear.push({
          value: currentYear,
          label: "Năm " + currentYear,
        });
        currentYear = currentYear - 1;
      }
      setOptionYear(listYear);
      setValue("year", listYear[0]);
    }
  }, [currentTime]);

  const objectAll = {
    value: "All",
    label: "Tất cả",
  };

  useEffect(() => {
    if (listKHHD.data) {
      setValue("khhdon", objectAll);
    }
  }, [listKHHD]);

  const OPTION_TYPE_TIME = [
    {
      value: "quarter",
      label: "Quý",
    },
    {
      value: "month",
      label: "Tháng",
    },
    {
      value: "date",
      label: "Khoảng thời gian",
    },
  ];
  const { addToast } = useToasts();

  const OPTION_quarter = [
    {
      value: "01",
      label: "Quý 1",
    },
    {
      value: "02",
      label: "Quý 2",
    },
    {
      value: "03",
      label: "Quý 3",
    },
    {
      value: "04",
      label: "Quý 4",
    },
  ];

  const OPTION_MONTH = [
    {
      value: "01",
      label: "Tháng 1",
    },
    {
      value: "02",
      label: "Tháng 2",
    },
    {
      value: "03",
      label: "Tháng 3",
    },
    {
      value: "04",
      label: "Tháng 4",
    },
    {
      value: "05",
      label: "Tháng 5",
    },
    {
      value: "06",
      label: "Tháng 6",
    },
    {
      value: "07",
      label: "Tháng 7",
    },
    {
      value: "08",
      label: "Tháng 8",
    },
    {
      value: "09",
      label: "Tháng 9",
    },
    {
      value: "10",
      label: "Tháng 10",
    },
    {
      value: "11",
      label: "Tháng 11",
    },
    {
      value: "12",
      label: "Tháng 12",
    },
  ];

  const OPTION_KHMSHDON = [
    // {
    //   value: "all",
    //   label: "Tất cả",
    // },
    {
      value: "1",
      label: "1 - HÓA ĐƠN GIÁ TRỊ GIA TĂNG ĐIỆN TỬ (TT78)",
    },
    {
      value: "2",
      label: "2 - HÓA ĐƠN BÁN HÀNG ĐIỆN TỬ (TT78)",
    },
    {
      value: "5",
      label: "5 - TEM VÉ ĐIỆN TỬ (TT78)",
    },
  ];

  const { t, i18n } = useTranslation(["summaryInvoiceData"]);
  const [commonStatus, setCommonStatus] = useState(getInvoiceStatus(t));

  const schema = yup.object().shape({
    // THông tin chung
    is_pos: yup.object(),
    typeTime: yup.object(),
    quarter: yup.object(),
    month: yup.object(),
    year: yup.object(),
    dateRange: yup.array().when(["typeTime"], {
      is: typeTime => typeTime.value === OPTION_TYPE_TIME[2].value,
      then: yup
        .array()
        .min(1, "Vui lòng chọn khoảng thời gian muốn xuất bảng tổng hợp"),
    }),
    bu_code_filter: yup
      .array()
      .min(1, "Vui lòng chọn đơn vị/chi nhánh")
      .nullable(),
    khmshdon: yup.object(),
    khhdon: yup.object().required("Vui lòng chọn"),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
    setFocus,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      is_pos: TypeHDList[0],
      typeTime: OPTION_TYPE_TIME[2],
      quarter: OPTION_quarter[0],
      month: OPTION_MONTH[0],
      khmshdon: OPTION_KHMSHDON[0],
      dateRange: [],
      bu_code_filter: [],
      //   khhdon: OPTION_KHHDON[0],
    },
  });

  const onSubmit = values => {
    console.log("🚀 ~ file: CreateData.js:302 ~ onSubmit ~ values:", values);
    setNameFile(null);
    const {
      khhdon,
      khmshdon,
      month,
      quarter,
      typeTime,
      year,
      bu_code_filter,
      is_pos,
    } = values;
    let params = null;
    if (typeTime.value === "quarter") {
      params = {
        quarter: quarter.value,
        year: year.value,
        type: khmshdon.value,
        // kyhieu: khhdon.value !== objectAll.value ? khhdon.value : undefined,
      };
    }
    if (typeTime.value === "month") {
      params = {
        month: month.value,
        year: year.value,
        type: khmshdon.value,
        // kyhieu: khhdon.value !== objectAll.value ? khhdon.value : undefined,
      };
    }
    if (typeTime.value === "date") {
      params = {
        date_from: convertDate(values.dateRange[0], "date"),
        date_to: convertDate(
          values.dateRange[1] ? values.dateRange[1] : values.dateRange[0],
          "date"
        ),
        type: 10,
        // kyhieu: khhdon.value !== objectAll.value ? khhdon.value : undefined,
      };
    }
    params = {
      ...params,
      bu_code: buStoreHeader === ALL_STORE ? buTenantHeader : buStoreHeader,
      bu_code_filter:
        buStoreHeader === ALL_STORE
          ? bu_code_filter.map(item => item.value)
          : [buStoreHeader],
      is_pos: is_pos?.value,
    };
    setNameFile("Bảng tổng hợp thông báo gửi CQT " + getTimeContent(params));
    dispatch(createReportInvoice({ ...params }, TYPE_REPORT.ERROR));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Lập Bảng tổng hợp thông báo gửi CQT</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs
            title=""
            breadcrumbItem={"Lập Bảng tổng hợp thông báo gửi CQT"}
          />
          <Card>
            <CardBody style={{ minHeight: "450px" }}>
              <Row className="row-cols-1 row-cols-md-3">
                {/* Loại */}
                {/* <Col style={{}}>
                  {generateSelectField(
                    "Loại",
                    true,
                    errors,
                    "typeTime",
                    "Vui lòng chọn",
                    false,
                    control,
                    OPTION_TYPE_TIME,
                    "auto",
                    () => {
                      //   const cqtqly = getValues(COMMON_FIELD.CQTQLY.field);
                      //   if (cqtqly?.code) {
                      //     setValue(COMMON_FIELD.MCQTQLY.field, cqtqly.code, {
                      //       shouldValidate: true,
                      //     });
                      //   }
                    },
                    true
                  )}
                </Col>
                {watch("typeTime").value === OPTION_TYPE_TIME[0].value && (
                  <Col style={{}}>
                    {generateSelectField(
                      "Quý",
                      true,
                      errors,
                      "quarter",
                      "Vui lòng chọn",
                      false,
                      control,
                      OPTION_quarter,
                      "auto",
                      () => {
                        //   const cqtqly = getValues(COMMON_FIELD.CQTQLY.field);
                        //   if (cqtqly?.code) {
                        //     setValue(COMMON_FIELD.MCQTQLY.field, cqtqly.code, {
                        //       shouldValidate: true,
                        //     });
                        //   }
                      },
                      true
                    )}
                  </Col>
                )}
                {watch("typeTime").value === OPTION_TYPE_TIME[1].value && (
                  <Col style={{}}>
                    {generateSelectField(
                      "Tháng",
                      true,
                      errors,
                      "month",
                      "Vui lòng chọn",
                      false,
                      control,
                      OPTION_MONTH,
                      "auto",
                      () => {
                        //   const cqtqly = getValues(COMMON_FIELD.CQTQLY.field);
                        //   if (cqtqly?.code) {
                        //     setValue(COMMON_FIELD.MCQTQLY.field, cqtqly.code, {
                        //       shouldValidate: true,
                        //     });
                        //   }
                      },
                      true
                    )}
                  </Col>
                )}*/}
                {watch("typeTime").value === OPTION_TYPE_TIME[2].value && (
                  <React.Fragment>
                    <Col style={{ width: "250px" }}>
                      {generateDateField(
                        "Từ ngày",
                        "Đến ngày",
                        false,
                        errors,
                        "dateRange",
                        "DD/MM/YYYY ~ DD/MM/YYYY",
                        false,
                        control,
                        {
                          ...optionDateLocale,
                          mode: "range",
                          //   enableTime: true,
                          //   dateFormat: "Y-m-d",
                          //   dateFormat: "H:i",
                          //   time_24hr: true,
                        }
                      )}
                    </Col>
                    <Col style={{}}>
                      {generateSelectField(
                        "Loại HĐ",
                        true,
                        errors,
                        "is_pos",
                        "Vui lòng chọn",
                        false,
                        control,
                        checkIsHaveInvoicePos(
                          buTenantHeaderInfo,
                          finalBuInfo,
                          buStoreHeader,
                          tenantCodeHeader
                        )
                          ? TypeHDList
                          : [TypeHDList[0]],
                        "auto",
                        e => {},
                        false,
                        false,
                        false,
                        false
                      )}
                    </Col>
                    <Col style={{}}>
                      {generateSelectField(
                        listBuStore?.length > 0 ? "Đơn vị" : "Chi nhánh",
                        true,
                        errors,
                        "bu_code_filter",
                        "Vui lòng chọn",
                        false,
                        control,
                        buStoreHeader === ALL_STORE
                          ? listBuStore && [
                              {
                                value: "all",
                                label: "Tất cả",
                              },
                              ...listBuStore.filter(
                                item => item.value !== ALL_STORE
                              ),
                            ]
                          : [
                              {
                                value: finalBuInfo?.code,
                                label:
                                  finalBuInfo?.code + " - " + finalBuInfo?.ten,
                              },
                            ],
                        "auto",
                        e => {
                          if (
                            e.findIndex(item => item.value === "all") !== -1
                          ) {
                            setValue(
                              "bu_code_filter",
                              listBuStore.filter(
                                item => item.value !== ALL_STORE
                              )
                            );
                          }
                        },
                        false,
                        false,
                        false,
                        true
                      )}
                    </Col>
                  </React.Fragment>
                )}
                {/* {watch("typeTime").value !== OPTION_TYPE_TIME[2].value && (
                  <Col style={{}}>
                    {generateSelectField(
                      "Năm",
                      true,
                      errors,
                      "year",
                      "Vui lòng chọn",
                      false,
                      control,
                      optionYear,
                      "auto",
                      () => {
                        //   const cqtqly = getValues(COMMON_FIELD.CQTQLY.field);
                        //   if (cqtqly?.code) {
                        //     setValue(COMMON_FIELD.MCQTQLY.field, cqtqly.code, {
                        //       shouldValidate: true,
                        //     });
                        //   }
                      },
                      true
                    )}
                  </Col>
                )} */}
              </Row>
              <Row className="row-cols-1 row-cols-md-3 mt-2">
                {/* <Col style={{}}>
                  {generateSelectField(
                    "Mẫu hóa đơn",
                    true,
                    errors,
                    "khmshdon",
                    "Vui lòng chọn",
                    false,
                    control,
                    OPTION_KHMSHDON,
                    "auto",
                    () => {
                      dispatch(
                        listKhddInvoiceToSummary(getValues("khmshdon").value)
                      );
                    },
                    true
                  )}
                </Col> */}
                {/* <Col style={{}}>
                  {listKHHD.loading ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "self-end",
                        height: "100%",
                        justifyContent: "center",
                      }}
                    >
                      <Spinner color="primary" />
                    </div>
                  ) : (
                    generateSelectField(
                      "Ký hiệu hóa đơn",
                      true,
                      errors,
                      "khhdon",
                      "Vui lòng chọn",
                      false,
                      control,
                      [
                        objectAll,
                        ...listKHHD.data.map(item => {
                          return {
                            value: item,
                            label: item,
                          };
                        }),
                      ],
                      "auto",
                      () => {
                        // dispatch(listKhddInvoiceToSummary());
                      },
                      false
                    )
                  )}
                </Col> */}
              </Row>
              <div className="mt-4 d-flex justify-content-center gap-2">
                <Button
                  color="danger"
                  className=" w-md"
                  type="submit"
                  onClick={() => {
                    history.push("/report/list-report-invoice-error");
                  }}
                >
                  Trở về
                </Button>
                <Button
                  style={{ marginTop: "2px" }}
                  type="button"
                  color="primary"
                  className="me-2 btn-label"
                  disabled={
                    createReportInvoiceData.loading ||
                    reportInvoiceProgress.isStart ||
                    buTenantHeader === ALL_BU
                  }
                  onClick={() => {
                    handleSubmit(onSubmit)();
                  }}
                >
                  <i className="bx bxs-report label-icon" />
                  Tạo bảng tổng hợp
                </Button>
              </div>
              {(reportInvoiceProgress.isStart ||
                reportInvoiceProgress.percent !== 0) && (
                <React.Fragment>
                  <Row className="mt-3 d-flex justify-content-center">
                    <div style={{ width: "80vw", height: "33px" }}>
                      <Label>
                        {" "}
                        <div className="d-flex justify-content-center align-items-end gap-2">
                          <i className=" far fa-file-excel text-success font-size-20" />
                          <strong>{nameFile + ".xlsx "}</strong>
                          {reportInvoiceProgress.percent === 100
                            ? ""
                            : "(Đang xử lý)"}
                        </div>
                      </Label>

                      <Progress
                        style={{ height: "33px" }}
                        animated
                        color="info"
                        striped
                        value={reportInvoiceProgress.percent}
                      >
                        <span style={{ fontSize: "20px" }}>
                          {reportInvoiceProgress.percent === 100 &&
                            "Hoàn tất xử lý"}{" "}
                          ({reportInvoiceProgress.percent + "%"})
                        </span>
                      </Progress>
                    </div>
                  </Row>
                  {reportInvoiceProgress.percent === 100 && (
                    <Row className="mt-4 d-flex justify-content-center">
                      <div
                        onClick={() => {
                          dispatch(
                            downloadReportInvoice(
                              reportInvoiceProgress.id,
                              nameFile
                            )
                          );
                        }}
                        className="mt-2 font-size-18 text-success d-flex align-items-center"
                        style={{ width: "fit-content", cursor: "pointer" }}
                      >
                        <i className="bx bx-download label-icon " />
                        Tải báo cáo
                      </div>
                    </Row>
                  )}
                </React.Fragment>
              )}
            </CardBody>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CreateData;
